import React from 'react'
import { Link } from 'react-router-dom'
import {Sparkles, Ticket} from 'lucide-react'

function WeirdTokyo() {
  const attractions = [
    {
      id: 1,
      name: 'Hedgehog Cafe',
      description: 'Cuddle with adorable hedgehogs while sipping coffee',
      image: 'https://images.unsplash.com/photo-1618945524163-32451704651e?w=600&q=80',
      price: '¥1,500',
      duration: '60 mins',
      link: '/article/hedgehog-cafe'
    },
    {
      id: 2,
      name: 'Life-Size Gundam',
      description: 'Marvel at the 18-meter moving robot statue',
      image: 'https://images.unsplash.com/photo-1589254065878-42c9da997008?w=600&q=80',
      price: 'Free',
      duration: '45 mins',
      link: '/article/gundam'
    },
    {
      id: 3,
      name: 'Maid Cafe Experience',
      description: 'Akihabara\'s famous themed cafe culture',
      image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=600&q=80',
      price: '¥2,000',
      duration: '90 mins',
      link: '/article/maid-cafe'
    },
    {
      id: 4,
      name: 'Robot Restaurant',
      description: 'Neon-soaked robot show extravaganza',
      image: 'https://images.unsplash.com/photo-1563207153-f403bf289096?w=600&q=80',
      price: '¥8,000',
      duration: '2 hours',
      link: '/article/robot-restaurant'
    },
    {
      id: 5,
      name: 'Owl Cafe',
      description: 'Get up close with friendly owls',
      image: 'https://images.unsplash.com/photo-1574870111867-089730e5a72b?w=600&q=80',
      price: '¥1,800',
      duration: '60 mins',
      link: '/article/owl-cafe'
    },
    {
      id: 6,
      name: 'TeamLab Borderless',
      description: 'Immersive digital art museum',
      image: 'https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?w=600&q=80',
      price: '¥3,200',
      duration: '2-3 hours',
      link: '/article/teamlab'
    }
  ]

  return (
    <div className="pt-16 min-h-screen bg-[#0A0A0A]">
      {/* Header */}
      <section className="relative py-20 px-4 bg-gradient-to-b from-[#FF006E]/20 to-transparent">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <Sparkles className="w-10 h-10 text-[#FF006E]" fill="#FF006E" />
            <h1 className="text-5xl md:text-6xl font-bold text-white">
              Weird <span className="text-[#FF006E]">Tokyo</span>
            </h1>
          </div>
          <p className="text-xl text-gray-300 max-w-3xl">
            Tokyo's most unique, quirky, and absolutely unforgettable attractions. 
            From animal cafes to robot shows, these experiences define Tokyo's wonderfully weird side.
          </p>
        </div>
      </section>

      {/* Attractions Grid */}
      <section className="max-w-7xl mx-auto px-4 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {attractions.map((attraction) => (
            <div
              key={attraction.id}
              className="group relative bg-[#1A1A1A] rounded-2xl overflow-hidden border-2 border-[#FF006E]/20 hover:border-[#FF006E] transition-all hover:transform hover:scale-105"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={attraction.image}
                  alt={attraction.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/30 to-transparent" />
                
                {/* Price Tag */}
                <div className="absolute top-4 right-4 bg-[#FF006E] text-white px-3 py-1 rounded-full font-bold text-sm shadow-lg">
                  {attraction.price}
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-[#FF006E] transition-colors">
                  {attraction.name}
                </h3>
                <p className="text-gray-400 mb-4">
                  {attraction.description}
                </p>

                <div className="flex items-center justify-between mb-4">
                  <span className="text-gray-500 text-sm">
                    ⏱️ {attraction.duration}
                  </span>
                  <Ticket className="w-5 h-5 text-[#FF006E]" />
                </div>

                {/* CTA Button */}
                <Link
                  to={attraction.link}
                  className="block w-full py-3 bg-gradient-to-r from-[#FF006E] to-[#CC0058] text-white font-bold rounded-full text-center hover:shadow-lg hover:shadow-[#FF006E]/50 transition-all"
                  style={{ boxShadow: '0 0 20px rgba(255, 0, 110, 0.3)' }}
                >
                  Check Ticket Availability
                </Link>
              </div>

              {/* Glow Effect */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                <div className="absolute inset-0 bg-gradient-to-t from-[#FF006E]/10 to-transparent" />
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-[#1A1A1A] to-[#0A0A0A] p-8 rounded-3xl border-2 border-[#FF006E]/30">
            <h3 className="text-2xl font-bold text-white mb-3">
              Book Multiple Attractions & Save
            </h3>
            <p className="text-gray-400 mb-6">
              Get combo deals on Tokyo's weird and wonderful experiences
            </p>
            <button className="px-8 py-4 bg-gradient-to-r from-[#FF006E] to-[#CC0058] text-white font-bold rounded-full hover:scale-105 transition-transform">
              View Combo Packages →
            </button>
          </div>
        </div>
      </section>
    </div>
  )
}

export default WeirdTokyo
